import { buildStreetLabelMap, streetLabel } from './buildStreetLabels';

/**
 * "Straat Huisnummer, Woonplaats" per huishouden, voor een keuzelijst.
 *
 * Leest de vaste gegevens op het huishouden en tot de migratie de oude
 * regels — dezelfde lezing als het overzicht (`buildStreetLabelMap`), zodat de
 * keuzelijst in een afspraak hetzelfde huishouden net zo noemt als de lijst.
 * Een huishouden zonder adres krijgt geen label; de afnemer kiest de terugval.
 * AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T7)
 *
 * @param {Array<{PersonaID?: string, Title?: string, Value?: string}>} [personaData]
 * @param {Array<{ID?: string}>} [adresses] - De `Adresses`-documenten
 * @returns {Record<string, string>}
 */
const buildAdressLabelMap = (personaData, adresses = []) => {
    const map = buildStreetLabelMap(personaData, adresses);
    /** @type {Record<string, string>} */
    const labels = {};

    Object.keys(map).forEach((id) => {
        const label = [streetLabel(map, id, ''), map[id].Woonplaats].filter(Boolean).join(', ');
        if (label) labels[id] = label;
    });

    return labels;
};

export default buildAdressLabelMap;
